<template>
  <div
    class="relative flex flex-col items-center justify-center min-h-[100dvh] max-h-[100dvh] bg-iq-grey-dark pt-16"
    :class="{
      'bg-iq-grey-dark': !selectedPaymemtMethod,
    }"
  >
    <Icon
      name="heroicons:arrow-left-20-solid"
      class="absolute icon-iq hover:cursor-pointer top-14 lg:top-4 left-4 stroke-iq-white text-iq-white"
      @click="cancelCheckout()"
    />
    <div
      v-if="!selectedPaymemtMethod"
      class="flex flex-col items-center justify-center w-full gap-4 sm:flex-row"
    >
      <div
        v-if="!paymentMethod || paymentMethod === 'card'"
        class="flex flex-col border-iq-white-border justify-center hover:cursor-pointer border-2 p-8 place-items-center min-h-[17.25rem] min-w-[18.5rem] max-h-[17.25rem] max-w-[18.5rem] h-69 w-74"
        @click="selectedPaymemtMethod = 'creditcard'"
      >
        <Icon class="w-12 h-12 mb-2" name="heroicons:credit-card" />
        <span class="lg:text-regular-22 text-regular-15">{{
          t('payment-selection')
        }}</span>
      </div>
      <div
        v-if="!paymentMethod || paymentMethod === 'customer_balance'"
        class="flex flex-col border-iq-white-border justify-center hover:cursor-pointer border-2 p-8 place-items-center min-h-[17.25rem] min-w-[18.5rem] max-h-[17.25rem] max-w-[18.5rem] h-69 w-74"
        @click="selectedPaymemtMethod = 'banktransfer'"
      >
        <Icon class="w-12 h-12 mb-2" name="heroicons:banknotes" />
        <span class="lg:text-regular-22 text-regular-15">{{
          t('bank-transfer')
        }}</span>
      </div>
    </div>
    <div
      v-if="paymentMethod && !selectedPaymemtMethod"
      class="flex items-center justify-center w-full p-4 pt-8"
    >
      <span class="w-[80%] text-center text-regular-16">{{
        t('text-payment-method-change')
      }}</span>
    </div>

    <TheCheckoutCreditCard
      v-if="selectedPaymemtMethod === 'creditcard'"
      :address="address"
      :checkout-identifier="checkoutIdentifier ?? ''"
      :name="name"
      :phone="phone"
      :price-id="priceId ?? ''"
      :vat-id="vatId"
      :company-name="companyName"
    />
    <TheCheckoutBankTransfer
      v-if="selectedPaymemtMethod === 'banktransfer'"
      :address="address"
      :checkout-identifier="checkoutIdentifier ?? ''"
      :name="name"
      :phone="phone"
      :price-id="priceId ?? ''"
      :vat-id="vatId"
      :company-name="companyName"
    />
  </div>
</template>
<script lang="ts" setup>
const route = useRoute();
const { t } = useI18n({
  useScope: 'local',
});
const address = ref<{
  line1: string;
  line2?: string | null;
  city: string;
  state: string;
  postal_code: string;
  country: string;
}>({ line1: '', line2: '', city: '', state: '', postal_code: '', country: '' });

const checkoutIdentifier = route.query.checkoutIdentifier?.toString();
const companyName = ref<string>('');
const name = ref<string>('');
const phone = ref<string>('');
const paymentMethod = ref('');
const priceId = route.query.priceId?.toString();
const selectedPaymemtMethod = ref<'creditcard' | 'banktransfer' | undefined>(
  undefined
);
const stripeUtil = stripeHelper('');
const vatId = ref<string | undefined>();

function cancelCheckout() {
  if (selectedPaymemtMethod.value) {
    // todo: @kai new tracking event ?

    return (selectedPaymemtMethod.value = undefined);
  }
  trackAtServer('cancel_checkout');
  useRouter().back();
}

onMounted(async () => {
  const customerData = await stripeUtil.retrieveCustomerData();
  const id = await stripeUtil.getVatId();
  if (id) {
    vatId.value = id;
  }

  if (customerData) {
    address.value = customerData.address;
    name.value = customerData.name;
    phone.value = customerData.phone;
    companyName.value = customerData.companyName;
    if (checkoutIdentifier === 'subscription') {
      paymentMethod.value = customerData.paymentMethod;
    }
  } else {
    address.value.country = 'DE';
  }
});
onUnmounted(() => {
  clearError();
});

useHead({
  title: 'B2BSCAN - Checkout',
});
</script>

<i18n lang="json">
{
  "de": {
    "payment-selection": " Kreditkarte / Paypal",
    "bank-transfer": "Banküberweisung",
    "text-payment-method-change": "*Wenn Sie ihre Zahlungsmethode für das Abonnement ändern möchten, kontaktieren Sie bitte den Support",
    "head-title": "B2BSCAN - Checkout"
  },
  "en": {
    "payment-selection": "Credit Card / Paypal",
    "bank-transfer": "Bank Transfer",
    "text-payment-method-change": "*If you want to change your payment method for the subscription, please contact support",
    "head-title": "B2BSCAN - Checkout"
  }
}
</i18n>
